// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"523":"09656e69a5afdec583d4","702":"12a8d2d3caa0bad6e430"}[chunkId] + ".css";
};